/**
 * 标签页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const tagsCommonConfig = {
  texts: {
    loading: 'Loading...',
    allTags: 'All Tags',
    mostPopular: 'Most popular',
    newArrival: 'New Arrival',
    noMore: 'No more ~',
  },
}
